import React from 'react';
import { graphql } from 'gatsby';

import { Divider } from 'modules/ui';
import { InquirySection } from 'modules/inquiry';
import { MarkdownContent } from 'modules/mdx/';

import { Hero } from './Hero';
import { AuthorBio } from './AuthorBio';
import { BlogContentContainer } from '../BlogContentContainer';
import { OtherPosts } from '../OtherPosts';
import type { BlogPost, BlogPostDetail } from '../../types';
import { MetadataContainer } from '../MetadataContainer';

export interface BlogPostDetailProps extends Omit<BlogPostDetail, 'seo'> {
    otherPosts: BlogPost[];
}

export const BlogPostDetailPage = ({
    title,
    author,
    categories,
    tags,
    publishedAt,
    thumbnail,
    content,
    otherPosts,
}: BlogPostDetailProps) => (
    <>
        <article>
            <Hero
                title={title}
                author={author}
                categories={categories}
                publishedAt={publishedAt}
                thumbnail={thumbnail}
            />
            <BlogContentContainer>
                <MarkdownContent body={content?.data.childMdx.body} />
                <MetadataContainer title={title} tags={tags} />
                <AuthorBio author={author} />
            </BlogContentContainer>
        </article>

        <OtherPosts posts={otherPosts} />

        {/** @ts-expect-error */}
        <Divider />
        <InquirySection />
    </>
);

export const postDetailQuery = graphql`
    fragment BlogPostDetail on STRAPI_POST {
        id
        title
        author {
            ...PostAuthor
        }
        content {
            data {
                childMdx {
                    body
                    excerpt(pruneLength: 160)
                }
            }
        }
        publishedAt
        updatedAt
        categories {
            ...PostCategory
        }
        tags {
            ...PostTag
        }
        thumbnail {
            url
            width
            height
            formats {
                large {
                    url
                    width
                    height
                }
            }
        }
        seo {
            metaTitle
            metaDescription
            keywords
            metaImage {
                url
                width
                height
            }
        }
    }
`;
